
const digest = '0768a60f81337e7bc06600a6a1586aff8725851bab6bae419e316e3c39572477';
const css = `._codeSnippet_arpso_1 {
  font-family: monospace;
  color: var(--theme-code-text, #d14);
  border: 1px solid var(--theme-primary-border, #e1e1e1);
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: var(--theme-secondary-background, #f7f7f7);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_arpso_1"};
export { css, digest };
  